export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const OTP_PENDING = "OTP_PENDING";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const USER_UPDATE = "USER_UPDATE";
export const IN8IT_LOGIN_FAIL = "IN8IT_LOGIN_FAIL";
